export default function Error() {
  return (
    <>
      <section className="max-width">
        <h1>Error page</h1>
      </section>
    </>
  )
}
